import { auditApi as api } from '../../api';
export const uploadVendor = async (fileData) => {
    try {
        const formData = new FormData();
        formData.append('file', fileData);
        const token = sessionStorage.getItem('token');
        const response = await api.post('/upload_vendors', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const addSingleVendor = async (formData) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/add_single_vendor', formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchVendor = async () => {
    try {
        const client_ID = sessionStorage.getItem('selectedClient')
        const response = await api.get(`/get_vendors`, {
            params: {
                client_id: client_ID
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const updateVendor = async (id,Data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_vendor/${id}`, Data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const deleteVendor = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_vendor/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}
export const multiDeleteVendor = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post('/multiple_delete_vendors', ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}
export const vendorLoginUser = async (data) => {
    try {
        const response = await api.post('/vendor-login', data);
        const token = response.data.access_token;
        if (token) {
          localStorage.setItem('token', token);
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('user', JSON.stringify(response.data.userData))
        }
        return {
          data: response.data,
          status: response.status,
          token: token,
        };
    } catch (error) {
        throw error.response ? error.response.data.message : error.message;
    }
}
export const vendorForgotPassword = async (userData) => {
  try {
    const response = await api.post('/vendor-forgot-password', userData);
    return {
      data: response.data,
      status: response.status
    };
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};
export const vendor_login_release = async (ids) => {
  try {
    const response = await api.post('/vendor-login-release', ids);
    return {
      data: response.data,
      status: response.status
    };
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};


export const updateVendorPassword = async (updateVendorData) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await api.post(`/vendor-change-password`, updateVendorData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data.message : error.message;
    }
  };

export const uploadVendorProfile = async (formData) => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await api.post(`/upload_vendor_spoc_profile`, formData, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};

export const fetchVendorProfile = async () => {
  try { 
    const token = sessionStorage.getItem("token");
    const response = await api.get(`/vendor_spoc_profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // { profile: "path/to/image.jpg" }
  } catch (error) {
    return { profile: null }; // fallback to null
  }
};

export const fetchVendorProfiles = async (vendorId) => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await api.get(`/vendor_spoc_profiles/${vendorId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return { profile: null };
  }
};



